export default __webpack_public_path__ + "static/media/usuario.82c5a75b.png";